import script from "./BetaBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./BetaBadge.vue?vue&type=script&setup=true&lang=ts"

import "./BetaBadge.vue?vue&type=style&index=0&id=f0b1e0ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0b1e0ca"]])

export default __exports__